import Model, { attr, belongsTo } from '@ember-data/model';

export default class ParametroModel extends Model {
  @belongsTo('empresa', { async: false, inverse: null }) empresa;

  @attr('string') parametro;

  @attr('string') valor;
}
